import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DeleteConfirmationModal } from "app/components";
import { CONSTANTS } from "app/constants";
import { MaintenanceLogDto } from "app/models";
import { MaintenanceService, NotificationService } from "app/services";

@Component({
    selector: 'admin-maintenance',
    templateUrl: 'admin-maintenance.page.html',
    styleUrls: ['../../../layouts/admin/admin.layout.scss', 'admin-maintenance.page.scss'],
})
export class AdminMaintenancePage implements OnInit {

    isProcessing: boolean = false;

    clearTransferBidsLog: MaintenanceLogDto;
    clearRentListLog: MaintenanceLogDto;
    clearTransferListLog: MaintenanceLogDto;
    backRentLog: MaintenanceLogDto;
    backRentLogHalfSeason: MaintenanceLogDto;
    midSeasonForm: MaintenanceLogDto;

    constructor(private modalService: NgbModal,
        private maintenanceService: MaintenanceService,
        private notificationService: NotificationService
    ) { }


    ngOnInit(): void {
        this.loadLatestLogs()
    }

    onClearTransferTender() {
        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                                modalRef2.componentInstance.title = "Удалить все ставки и трансферные предложения";
                                modalRef2.result.then((result) => {
                                    if (result) {
                                       this.maintenanceService.clearTransferBids()
                                        .subscribe(result => {
                                            this.clearTransferBidsLog = result;
                                            this.notificationService.showSuccess('Трансферные ставки успешно удалены');
                                        }, error => {
                                            this.notificationService.showError('Не удалось удалить трансферные ставки.');
                                        })
                                    }
                                });
    }

    onClearRentList() {
        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                                modalRef2.componentInstance.title = "Очистить арендный список";
                                modalRef2.result.then((result) => {
                                    if (result) {
                                       this.maintenanceService.clearRentList()
                                        .subscribe(result => {
                                            this.clearRentListLog = result;
                                            this.notificationService.showSuccess('Арендный список очищен');
                                        }, error => {
                                            this.notificationService.showError('Не удалось очистить арендный список.');
                                        })
                                    }
                                });
    }

    onClearTransferList() {
        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                                modalRef2.componentInstance.title = "Очистить трансферный список";
                                modalRef2.result.then((result) => {
                                    if (result) {
                                       this.maintenanceService.clearTransferList()
                                        .subscribe(result => {
                                            this.clearTransferListLog = result;
                                            this.notificationService.showSuccess('Трансферный список очищен');
                                        }, error => {
                                            this.notificationService.showError('Не удалось очистить трансферный список.');
                                        })
                                    }
                                });
    }

    onBackRent() {
        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                                modalRef2.componentInstance.title = "Вернуть арендованных домой";
                                modalRef2.result.then((result) => {
                                    if (result) {
                                       this.maintenanceService.backRent()
                                        .subscribe(result => {
                                            this.backRentLog = result;
                                            this.notificationService.showSuccess('Арендованные игроки возвратились по домам');
                                        }, error => {
                                            this.notificationService.showError('Не удалось вернуть арендованных игроков.');
                                        })
                                    }
                                });
    }

    onBackRentHalfSeason() {
        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                                modalRef2.componentInstance.title = "Вернуть арендованных на полсезона домой";
                                modalRef2.result.then((result) => {
                                    if (result) {
                                       this.maintenanceService.backRentHalfSeason()
                                        .subscribe(result => {
                                            this.backRentLog = result;
                                            this.notificationService.showSuccess('Арендованные на полсезона игроки возвратились по домам');
                                        }, error => {
                                            this.notificationService.showError('Не удалось вернуть арендованных игроков.');
                                        })
                                    }
                                });
    }

    onMidSeasonForm() {
        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                                modalRef2.componentInstance.title = "Восстановить межкружную форму и мораль";
                                modalRef2.result.then((result) => {
                                    if (result) {
                                       this.maintenanceService.setMidSeasonForm()
                                        .subscribe(result => {
                                            this.midSeasonForm = result;
                                            this.notificationService.showSuccess('Мораль и форма установлены');
                                        }, error => {
                                            this.notificationService.showError('Не удалось установить мораль и форму.');
                                        })
                                    }
                                });
    }

    onClearCache() {
        this.maintenanceService.clearCache()
            .subscribe(result => {
                this.notificationService.showSuccess('Кэш очищен');
            }, error => {
                this.notificationService.showError('Ошибка очистки кэша');
            })
    }


    private loadLatestLogs() {
        this.maintenanceService.getLatestLogs()
            .subscribe(result => {
                let clearTransferBidsLog = result.find(l => l.maintenanceType == CONSTANTS.maintenanceJobs.clearTransfers);
                let clearRentListLog = result.find(l => l.maintenanceType == CONSTANTS.maintenanceJobs.clearRentList);
                let clearTransferListLog = result.find(l => l.maintenanceType == CONSTANTS.maintenanceJobs.clearTransferList);
                let backRentLog = result.find(l => l.maintenanceType == CONSTANTS.maintenanceJobs.backRent);
                let midSeasonForm = result.find(l => l.maintenanceType == CONSTANTS.maintenanceJobs.midSeasonForm);
                let backRentLogHalfSeason = result.find(l => l.maintenanceType == CONSTANTS.maintenanceJobs.backRentLogHalfSeason);

                if (clearTransferBidsLog) {
                    this.clearTransferBidsLog = clearTransferBidsLog;
                }

                if (clearRentListLog) {
                    this.clearRentListLog = clearRentListLog;
                }
                if (clearTransferListLog) {
                    this.clearTransferListLog = clearTransferListLog;
                }
                if (backRentLog) {
                    this.backRentLog = backRentLog;
                }
                if (backRentLogHalfSeason) {
                    this.backRentLogHalfSeason = backRentLogHalfSeason;
                }
                if (midSeasonForm) {
                    this.midSeasonForm = midSeasonForm;
                }
            })
    }
}